import { useRef, type KeyboardEvent } from 'react';

// Auswahl als Chips (z. B. Kundenart): eine Gruppe von Radio-Knöpfen. Mit Tab erreicht man nur den gewählten Chip,
// die Pfeiltasten wechseln die Auswahl (wie bei normalen Radio-Knöpfen).
export function ChipRadios<T extends string>({
  label,
  value,
  options,
  onChange,
  className,
}: {
  label: string;
  value: T | '';
  options: readonly (readonly [T, string])[];
  onChange(v: T): void;
  className?: string;
}) {
  const refs = useRef<(HTMLButtonElement | null)[]>([]);
  const chosen = options.findIndex(([v]) => v === value);
  function onKey(e: KeyboardEvent, i: number) {
    const step = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
    if (!step) return;
    e.preventDefault();
    const n = (i + step + options.length) % options.length;
    onChange(options[n]![0]);
    refs.current[n]?.focus();
  }
  return (
    <div className={`rt-chips rt-radios${className ? ` ${className}` : ''}`} role="radiogroup" aria-label={label}>
      {options.map(([v, text], i) => (
        <button
          key={v}
          ref={(el) => {
            refs.current[i] = el;
          }}
          type="button"
          role="radio"
          aria-checked={value === v}
          tabIndex={i === (chosen < 0 ? 0 : chosen) ? 0 : -1}
          className={`rt-chip${value === v ? ' on' : ''}`}
          onClick={() => onChange(v)}
          onKeyDown={(e) => onKey(e, i)}
        >
          {text}
        </button>
      ))}
    </div>
  );
}
